import { useSelector } from 'react-redux';
import { IEnquiriesUserLimitModal } from '@bridebook/web/components/enquiries/enquiries-user-limit/enquiries-user-limit-modal/index';
import { IApplicationState } from '@bridebook/web/lib/types';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { memo } from 'react';

const EnquiriesUserLimitModal = lazyComponent<IEnquiriesUserLimitModal>(
  () =>
    import('@bridebook/web/components/enquiries/enquiries-user-limit/enquiries-user-limit-modal'),
);

interface EnquiriesUserLimitModalLazyProps {}

const EnquiriesUserLimitModalLazy: React.FC<EnquiriesUserLimitModalLazyProps> = () => {
  const show = useSelector<IApplicationState, boolean>((state) => state.enquiries.showUserLimit);
  if (!show) return null;

  return <EnquiriesUserLimitModal show={show} />;
};

export default memo(EnquiriesUserLimitModalLazy);
